// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Point} from './point.js'

export class StyleMap {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): StyleMap {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  backingPencilSeed(): number {
    return this.bb!.readInt32(this.bb_pos)
  }

  backingPencilReferencePoint(obj?: Point): Point | null {
    return (obj || new Point()).__init(this.bb_pos + 4, this.bb!)
  }

  backingDashPhase(): number {
    return this.bb!.readFloat32(this.bb_pos + 12)
  }

  backingDashPeriod(): number {
    return this.bb!.readFloat32(this.bb_pos + 16)
  }

  static sizeOf(): number {
    return 20
  }

  static createStyleMap(
    builder: flatbuffers.Builder,
    backing_pencil_seed: number,
    backing_pencil_reference_point_x: number,
    backing_pencil_reference_point_y: number,
    backing_dash_phase: number,
    backing_dash_period: number
  ): flatbuffers.Offset {
    builder.prep(4, 20)
    builder.writeFloat32(backing_dash_period)
    builder.writeFloat32(backing_dash_phase)
    builder.prep(4, 8)
    builder.writeFloat32(backing_pencil_reference_point_y)
    builder.writeFloat32(backing_pencil_reference_point_x)
    builder.writeInt32(backing_pencil_seed)
    return builder.offset()
  }
}
